import { Tabs, TabsBarItem, TabsType } from '@bg-components/Tabs';
import { t } from '@bg-shared';
import { LobbyTabId } from './enums';
import { ILobbyTab } from './interfaces';

interface ILobbyTabsProps {
    activeTabId: LobbyTabId;
    onTabChange: (id: number) => void;
    tabs: ILobbyTab[];
    allTabSelected?: boolean;
}

export const LobbyTabs = (props: ILobbyTabsProps): JSX.Element => (
    <Tabs
        onChange={(id) => props.onTabChange(id as number)}
        type={TabsType.lobby}
        inLobby
        allTabSelected={props.allTabSelected}
    >
        {props.tabs.map((tab) => (
            <TabsBarItem
                type={TabsType.lobby}
                key={tab.id}
                value={tab.id}
                active={tab.id === props.activeTabId}
            >
                <span>{tab?.icon && <tab.icon />}</span>
                {t.gamesCategories(tab.title)}
            </TabsBarItem>
        ))}
    </Tabs>
);
